/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Acted Core API
 * Core backend API.
 * OpenAPI spec version: 1.0.0
 */
import {
  HttpClient
} from '@angular/common/http';
import type {
  HttpContext,
  HttpEvent,
  HttpParams
} from '@angular/common/http';

import type {
  HttpHeaders,
  HttpResponse as AngularHttpResponse
} from '@angular/common/http';

import {
  Injectable,
  inject
} from '@angular/core';

import type {
  Observable
} from 'rxjs';

import type {
  CountriesGeojsonListParams,
  CountriesGetAuditLogListParams,
  CountriesListParams,
  CountriesRenderPlaceTreeRetrieveParams,
  CountryDetail,
  CountryDetailRequest,
  ExportRequestRequest,
  LongRunningJob,
  PaginatedCountryListGeoJSONList,
  PaginatedCountryListItemList,
  PaginatedLogEntryList,
  PatchedCountryDetailRequest
} from '../model';

import {
  environment
} from 'environments/environment';



import { filterParams, HttpClientBodyOptions, HttpClientEventOptions, HttpClientObserveOptions, HttpClientResponseOptions } from '../httpClientOptions';

@Injectable({ providedIn: 'root' })
export class CountriesService {
  private readonly http = inject(HttpClient);
 list<TData = PaginatedCountryListItemList>(params?: CountriesListParams, options?: HttpClientBodyOptions): Observable<TData>;
 list<TData = PaginatedCountryListItemList>(params?: CountriesListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 list<TData = PaginatedCountryListItemList>(params?: CountriesListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  list<TData = PaginatedCountryListItemList>(
    params?: CountriesListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/countries/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/countries/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `${environment.apiRoot}/api/countries/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
 create<TData = CountryDetail>(countryDetailRequest: CountryDetailRequest, options?: HttpClientBodyOptions): Observable<TData>;
 create<TData = CountryDetail>(countryDetailRequest: CountryDetailRequest, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 create<TData = CountryDetail>(countryDetailRequest: CountryDetailRequest, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  create<TData = CountryDetail>(
    countryDetailRequest: CountryDetailRequest, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `${environment.apiRoot}/api/countries/`,
      countryDetailRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `${environment.apiRoot}/api/countries/`,
      countryDetailRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `${environment.apiRoot}/api/countries/`,
      countryDetailRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
 retrieve<TData = CountryDetail>(codeIso: string, options?: HttpClientBodyOptions): Observable<TData>;
 retrieve<TData = CountryDetail>(codeIso: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 retrieve<TData = CountryDetail>(codeIso: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  retrieve<TData = CountryDetail>(
    codeIso: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/countries/${codeIso}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/countries/${codeIso}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `${environment.apiRoot}/api/countries/${codeIso}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
 update<TData = CountryDetail>(codeIso: string,
    countryDetailRequest: CountryDetailRequest, options?: HttpClientBodyOptions): Observable<TData>;
 update<TData = CountryDetail>(codeIso: string,
    countryDetailRequest: CountryDetailRequest, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 update<TData = CountryDetail>(codeIso: string,
    countryDetailRequest: CountryDetailRequest, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  update<TData = CountryDetail>(
    codeIso: string,
    countryDetailRequest: CountryDetailRequest, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(
      `${environment.apiRoot}/api/countries/${codeIso}/`,
      countryDetailRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(
      `${environment.apiRoot}/api/countries/${codeIso}/`,
      countryDetailRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.put<TData>(
      `${environment.apiRoot}/api/countries/${codeIso}/`,
      countryDetailRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
 partialUpdate<TData = CountryDetail>(codeIso: string,
    patchedCountryDetailRequest?: PatchedCountryDetailRequest, options?: HttpClientBodyOptions): Observable<TData>;
 partialUpdate<TData = CountryDetail>(codeIso: string,
    patchedCountryDetailRequest?: PatchedCountryDetailRequest, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 partialUpdate<TData = CountryDetail>(codeIso: string,
    patchedCountryDetailRequest?: PatchedCountryDetailRequest, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  partialUpdate<TData = CountryDetail>(
    codeIso: string,
    patchedCountryDetailRequest?: PatchedCountryDetailRequest, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `${environment.apiRoot}/api/countries/${codeIso}/`,
      patchedCountryDetailRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `${environment.apiRoot}/api/countries/${codeIso}/`,
      patchedCountryDetailRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.patch<TData>(
      `${environment.apiRoot}/api/countries/${codeIso}/`,
      patchedCountryDetailRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
 destroy<TData = void>(codeIso: string, options?: HttpClientBodyOptions): Observable<TData>;
 destroy<TData = void>(codeIso: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 destroy<TData = void>(codeIso: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  destroy<TData = void>(
    codeIso: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `${environment.apiRoot}/api/countries/${codeIso}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `${environment.apiRoot}/api/countries/${codeIso}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `${environment.apiRoot}/api/countries/${codeIso}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * return a list of AuditLogEntries for the given object
 */
 getAuditLog<TData = PaginatedLogEntryList>(codeIso: string,
    params?: CountriesGetAuditLogListParams, options?: HttpClientBodyOptions): Observable<TData>;
 getAuditLog<TData = PaginatedLogEntryList>(codeIso: string,
    params?: CountriesGetAuditLogListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getAuditLog<TData = PaginatedLogEntryList>(codeIso: string,
    params?: CountriesGetAuditLogListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getAuditLog<TData = PaginatedLogEntryList>(
    codeIso: string,
    params?: CountriesGetAuditLogListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/countries/${codeIso}/get-audit-log/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/countries/${codeIso}/get-audit-log/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `${environment.apiRoot}/api/countries/${codeIso}/get-audit-log/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
/**
 * Render the "place organigramme" for this Country, based on `Place.parent_place`
 */
 renderPlaceTree(codeIso: string,
    params?: CountriesRenderPlaceTreeRetrieveParams, options?: HttpClientBodyOptions): Observable<Blob>;
 renderPlaceTree(codeIso: string,
    params?: CountriesRenderPlaceTreeRetrieveParams, options?: HttpClientEventOptions): Observable<HttpEvent<Blob>>;
 renderPlaceTree(codeIso: string,
    params?: CountriesRenderPlaceTreeRetrieveParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<Blob>>;
  renderPlaceTree(
    codeIso: string,
    params?: CountriesRenderPlaceTreeRetrieveParams, options?: HttpClientObserveOptions): Observable<Blob | HttpEvent<Blob> | AngularHttpResponse<Blob>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get(
      `${environment.apiRoot}/api/countries/${codeIso}/render-place-tree/`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    ) as Observable<HttpEvent<Blob>>;
    }

    if (options?.observe === 'response') {
      return this.http.get(
      `${environment.apiRoot}/api/countries/${codeIso}/render-place-tree/`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    ) as Observable<AngularHttpResponse<Blob>>;
    }

    return this.http.get(
      `${environment.apiRoot}/api/countries/${codeIso}/render-place-tree/`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    ) as Observable<Blob>;
  }
 _export<TData = LongRunningJob>(exportRequestRequest?: ExportRequestRequest, options?: HttpClientBodyOptions): Observable<TData>;
 _export<TData = LongRunningJob>(exportRequestRequest?: ExportRequestRequest, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 _export<TData = LongRunningJob>(exportRequestRequest?: ExportRequestRequest, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  _export<TData = LongRunningJob>(
    exportRequestRequest?: ExportRequestRequest, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `${environment.apiRoot}/api/countries/export/`,
      exportRequestRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `${environment.apiRoot}/api/countries/export/`,
      exportRequestRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `${environment.apiRoot}/api/countries/export/`,
      exportRequestRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
 geojson<TData = PaginatedCountryListGeoJSONList>(params?: CountriesGeojsonListParams, options?: HttpClientBodyOptions): Observable<TData>;
 geojson<TData = PaginatedCountryListGeoJSONList>(params?: CountriesGeojsonListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 geojson<TData = PaginatedCountryListGeoJSONList>(params?: CountriesGeojsonListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  geojson<TData = PaginatedCountryListGeoJSONList>(
    params?: CountriesGeojsonListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/countries/geojson/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/countries/geojson/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `${environment.apiRoot}/api/countries/geojson/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
};

